export default {
  app: {
    // 菜单名称翻译 (key = 数据库中的中文名)
    menu: {
      '首页': '首页',
      '仪表盘': '仪表盘',
      '系统管理': '系统管理',
      '用户管理': '用户管理',
      '角色管理': '角色管理',
      '菜单管理': '菜单管理',
      '素材管理': '素材管理',
      '素材库': '素材库',
      '素材采集': '素材采集',
      '下载任务': '下载任务',
      'FB采集': 'FB采集',
      '报表中心': '报表中心',
      '消耗明细': '消耗明细',
      '书籍汇总': '书籍汇总',
      '有素材明细的书籍': '有素材明细的书籍',
      '素材消耗': '素材消耗',
      'Facebook 账户绑定': 'Facebook 账户绑定',
      '标签管理': '标签管理',
      '数据面板': '数据面板',
      '广告管理': '广告管理',
      '广告模板': '广告模板',
      '批量创建': '批量创建',
      '批量创建(测试)': '批量创建(测试)',
      '开发工具': '开发工具',
      '定时任务': '定时任务',
      '定时任务日志': '定时任务日志',
      '系统配置': '系统配置',
      '部门管理': '部门管理',
      'FB调试工具': 'FB调试工具'
    },
    // Header
    home: '首页',
    profile: '个人中心',
    settings: '账户设置',
    logout: '退出登录',
    unknownPage: '未知页面',
    user: '用户',
    // Tab 右键菜单
    tabCloseCurrent: '关闭当前',
    tabCloseLeft: '关闭左侧',
    tabCloseRight: '关闭右侧',
    tabCloseOthers: '关闭其他',
    tabCloseAll: '关闭全部'
  },
  common: {
    search: '搜索',
    reset: '重置',
    close: '关闭',
    confirm: '确定',
    cancel: '取消',
    delete: '删除',
    edit: '编辑',
    export: '导出',
    operation: '操作',
    status: '状态',
    createTime: '创建时间',
    yes: '是',
    no: '否',
    all: '全部',
    detail: '明细',
    image: '图片',
    video: '视频',
    exportLargeTitle: '导出数据量较大',
    exportLargeMessage: '当前条件下预计导出约 {count} 行（超过 1 万行），是否确定仍要导出？',
    exportCountFail: '获取导出条数失败，请稍后重试',
    /** 报表等多处共用的书名列与书名搜索框占位（与后端书名模糊匹配一致） */
    bookName: '书名',
    bookNameSearchPlaceholder: '按书名模糊搜索',
    /** 数据面板多页共用的消耗日期与区间占位 */
    consumptionDate: '消耗日期',
    dateRangeSep: '至',
    dateStart: '开始日期',
    dateEnd: '结束日期',
    min: '最小',
    max: '最大',
    sortDesc: '降序',
    sortAsc: '升序'
  },
  facebook: {
    title: 'Facebook 账户绑定',
    // 状态提示
    authExpired: '授权已失效',
    authExpiredDesc: '当前绑定的 Facebook 授权 Token 已过期或被撤销，请重新授权。',
    reAuth: '重新授权',
    notBound: '未绑定',
    notBoundDesc: '请先授权绑定',
    authSuccess: '授权成功',
    tokenActive: 'Token 状态正常',
    // 按钮
    bindFacebook: '绑定 Facebook 账户',
    unbind: '解除绑定',
    refreshBm: '刷新 BM/账户',
    addOAuth: '添加OAuth授权',
    addToken: '添加令牌绑定',
    // 表格
    accountCount: '已绑定的 Facebook 账户（{count} 个）',
    accountName: '账户名称',
    bindType: '绑定方式',
    primaryAccount: '主账户',
    bindTime: '绑定时间',
    editName: '编辑名称',
    saveName: '保存',
    setPrimary: '设为主账户',
    // Token绑定对话框
    tokenDialogTitle: '通过令牌绑定 Facebook 账户',
    tokenType: 'Token 类型',
    tokenTypeBm: 'BM 级 Token',
    tokenTypeAccount: '账户级 Token',
    accessToken: 'Access Token',
    accessTokenPlaceholder: '请输入 Facebook Access Token',
    adAccountId: '广告账户 ID',
    adAccountIdPlaceholder: '请输入广告账户ID，如 act_123456',
    tokenName: 'Token 名称 (可选)',
    tokenNamePlaceholder: '给这个 Token 起个名字',
    confirmBind: '确认绑定',
    // 验证
    tokenRequired: '请输入 Access Token',
    adAccountRequired: '账户级 Token 必须填写广告账户 ID',
    // 绑定方式文本
    bindTypeOAuth: 'OAuth 授权',
    bindTypeToken: '令牌绑定',
    // 状态文本
    statusActive: '正常',
    statusInactive: '已失效',
    // 消息
    unbindConfirm: '确定解除绑定？解除后需要重新授权',
    unbindSuccess: '已解除绑定',
    bindSuccess: '绑定成功',
    deleteConfirm: '确定删除该账户？',
    deleteSuccess: '删除成功',
    setPrimarySuccess: '已设为主账户',
    nameUpdateSuccess: '名称已更新',
    refreshSuccess: 'BM/账户刷新完成'
  },
  consumption: {
    // 搜索表单
    materialName: '素材名称',
    materialNamePlaceholder: '模糊搜索',
    numericId: '素材ID',
    numericIdPlaceholder: '回车累加，可粘贴多个',
    materialId: 'FB素材ID',
    materialIdPlaceholder: '外部ID精确匹配',
    materialType: '素材类型',
    fileType: '文件类型',
    fileTypePlaceholder: '如 image/jpeg',
    adAccountId: '广告账户ID',
    adAccountIdPlaceholder: '广告账户ID',
    adId: '广告ID',
    adIdPlaceholder: 'Facebook广告ID',
    tag: '标签',
    tagPlaceholder: '全部标签',
    uploader: '上传人',
    uploaderPlaceholder: '全部上传人',
    namingStrategy: '命名策略',
    namingStrategyPlaceholder: '全部策略',
    metricFilter: '指标筛选',
    hideMetricFilter: '收起筛选',
    adCountMin: '投放次数大于',
    adCountMinPlaceholder: '最小投放次数',
    adCountMax: '投放次数小于',
    adCountMaxPlaceholder: '最大投放次数',
    spendMin: '消耗大于',
    spendMinPlaceholder: '最小消耗',
    spendMax: '消耗小于',
    spendMaxPlaceholder: '最大消耗',
    ctrMin: '点击率大于',
    ctrMax: '点击率小于',
    purchasesMin: '购物次数大于',
    purchasesMinPlaceholder: '最小购物次数',
    purchasesMax: '购物次数小于',
    purchasesMaxPlaceholder: '最大购物次数',
    roiMin: 'ROI大于',
    roiMinPlaceholder: '最小ROI',
    roiMax: 'ROI小于',
    roiMaxPlaceholder: '最大ROI',
    costPerPurchaseMin: '单次购物费用大于',
    costPerPurchaseMinPlaceholder: '最小单次购物费用',
    costPerPurchaseMax: '单次购物费用小于',
    costPerPurchaseMaxPlaceholder: '最大单次购物费用',
    onlyWithSpend: '仅有消耗',
    queryEngine: '查询引擎',
    exportExcel: '导出Excel',
    // 日期快捷
    last7days: '近7天',
    last30days: '近30天',
    last90days: '近90天',
    // 空数据提示
    noDataTitle: '当前日期范围内无消耗数据',
    noDataDesc: '请尝试调整消耗日期范围，或关闭「仅有消耗」开关查看全部素材。',
    // 表格列
    material: '素材',
    spend: '消耗',
    impressions: '曝光',
    clicks: '点击',
    ctr: '点击率',
    cpm: '千展(CPM)',
    cpc: '点击价格(CPC)',
    purchases: '购物次数',
    costPerPurchase: '单次购物费用',
    purchaseValue: '购物转化价值',
    roi: 'ROI',
    adCount: '关联广告数',
    mimeType: '文件类型',
    // 每日明细对话框
    dailyDetailTitle: '每日消耗明细 — ',
    date: '日期',
    impressionsShort: '展示量',
    clicksShort: '点击量',
    purchasesShort: '购物',
    purchaseValueShort: '购物价值',
    summaryLabel: '全部汇总（共 {total} 条）：',
    // 导出
    exportConfirm: '确认导出当前筛选条件下的素材消耗数据?',
    exportTip: '提示',
    exportSuccess: '导出成功',
    exportFail: '导出失败',
    exportFileName: '素材消耗报表.xlsx',
    // 批量操作
    batchMoveToFolder: '批量移动到文件夹',
    batchMoveDialogTitle: '批量移动素材',
    batchMoveTip: '已选择 {count} 个素材',
    batchMoveTarget: '目标文件夹',
    batchMoveConfirm: '确认移动',
    batchMoveNoSelection: '请先选择要移动的素材',
    batchMoveSuccess: '移动成功',
    batchMoveFail: '移动失败',
    unfiled: '未归档'
  },
  insights: {
    // 搜索
    accountId: '账户ID',
    accountIdPlaceholder: '广告账户ID',
    campaignId: '系列ID',
    campaignName: '系列名称',
    adsetId: '组ID',
    // 维度 Tab
    dimAccount: '账户',
    dimCampaign: '系列',
    dimAdset: '广告组',
    dimAd: '广告',
    dimUser: '用户',
    // 表格列
    adAccountId: '账户ID',
    createUserName: '用户',
    adAccountName: '账户名称',
    accountBalance: '余额',
    campaignIdCol: '系列ID',
    adsetIdCol: '广告组ID',
    adIdCol: '广告ID',
    spend: '消耗',
    impressions: '曝光',
    clicks: '点击',
    ctr: '点击率',
    purchases: '购物',
    costPerPurchase: '单次购物费用',
    purchaseValue: '购物价值',
    dailyDetail: '每日明细',
    // 汇总
    summaryLabel: '当前页合计 ({count} 条 / 共 {total} 条):',
    // 每日明细对话框
    dailyTitle: '每日消耗明细 — ',
    date: '日期',
    impressionsShort: '展示量',
    clicksShort: '点击量',
    // 日期快捷
    last7days: '近7天',
    last14days: '近14天',
    last30days: '近30天',
    // 维度前缀
    prefixAccount: '账户: ',
    prefixCampaign: '系列: ',
    prefixAdset: '广告组: ',
    prefixAd: '广告: ',
    prefixUser: '用户: '
  },
  bookSummary: {
    operatorName: '投手',
    operatorPlaceholder: '全部投手',
    spend: '消耗',
    ctr: '点击率',
    purchases: '购物',
    costPerPurchase: '单次购物费用',
    purchaseValue: '购物价值',
    roi: 'ROI',
    viewDetail: '查看明细',
    materialDialogTitle: '素材明细 — ',
    materialTopTitle: 'ROI 最高的 20 个素材',
    noMaterial: '暂无关联素材数据',
    noBookName: '无法获取书名',
    loadMaterialFailed: '加载素材明细失败：',
    last7days: '近7天',
    last14days: '近14天',
    last30days: '近30天',
    summaryLabel: '全部汇总（共 {total} 条）：',
    moreFilter: '指标筛选',
    hideFilter: '收起筛选'
  },
  userSummary: {
    userName: '创建人',
    userNamePlaceholder: '按创建人搜索',
    spend: '消耗',
    ctr: '点击率',
    purchases: '购物',
    costPerPurchase: '单次购物费用',
    purchaseValue: '购物价值',
    viewDaily: '每日明细',
    dailyDialogTitle: '每日明细 — ',
    date: '日期',
    noUserName: '无法获取创建人',
    noData: '暂无数据',
    loadDailyFailed: '加载每日明细失败：',
    last7days: '近7天',
    last14days: '近14天',
    last30days: '近30天',
    summaryLabel: '全部汇总（共 {total} 条）：',
    moreFilter: '更多筛选',
    hideFilter: '收起筛选'
  },
  /** 策略分析页（与消耗明细维度文案对齐，独有项放此命名空间） */
  strategyAnalysis: {
    dimStrategy: '策略',
    strategyName: '策略名称',
    batchSuccessCount: '投放次数',
    account: '账户',
    accountPlaceholder: '账户ID或名称',
    campaignPlaceholder: '系列ID或名称',
    adsetPlaceholder: '广告组ID或名称',
    adPlaceholder: '广告ID或名称',
    costPerPurchaseShort: '单次费用',
    totalSpend: '总消耗',
    totalPurchases: '总购物',
    impressions: '展示',
    cpm: 'CPM',
    cpc: 'CPC',
    linkedMaterials: '关联素材',
    sortBy: '排序',
    sortOptionCtr: '点击率(CTR)',
    pageSummary: '本页汇总（共 {count} 条）：',
    ctrInCard: '点击率(CTR)',
    costPerPurchaseCard: '单次购物费用',
    noMaterials: '暂无关联素材',
    warnNoStrategyContext: '当前行缺少命名策略上下文，无法筛选关联素材',
    warnInvalidStrategyId: '命名策略 ID 无效',
    loadMaterialsFail: '加载关联素材失败或超时',
    exportConfirm: '确认导出当前筛选条件下的数据？',
    exportTipTitle: '导出提示',
    exportFileName: '策略数据报表.xlsx',
    exportSuccess: '导出成功',
    exportFail: '导出失败',
    currentRowFallback: '当前行'
  },
  booksWithMaterials: {
    pageDesc: '以下书籍在「书籍汇总」中点击「查看明细」时会展示素材数据，方便识别哪些书有消耗关联。',
    accountId: '账户ID',
    accountIdPlaceholder: '可选，按账户过滤',
    adAccountId: '广告账户ID',
    accountName: '账户名称',
    viewInSummary: '在书籍汇总中查看',
    emptyTip: '暂无有素材明细的书籍',
    helpTitle: '排查建议：',
    help1: '1. material_ad_mapping 需有 fb_ad_id 映射（批创投放、旧系统同步或 docs/sql/tools/02_manual_mapping_match.sql 手动补全）',
    help2: '2. fact_insights_daily 在所选日期范围内需有同步数据（消耗/曝光 > 0）',
    help3: '3. dim_campaign_book 需包含对应 campaign 的书名（维表同步任务）',
    help4: '4. 日期范围须包含 CK 中 fact_insights_daily 的实际数据（诊断 SQL 的 min_date~max_date），否则查询为空',
    resultTip: '共 {total} 本书有素材明细（分页展示）'
  },
  adTemplate: {
    title: '广告模板管理',
    templateName: '模板名称',
    templateNamePlaceholder: '请输入模板名称',
    isDefault: '是否默认',
    default: '默认',
    description: '描述',
    remark: '备注',
    createdAt: '创建时间',
    copy: '复制',
    // Dialog
    addTitle: '新增Facebook广告模板',
    editTitle: '修改Facebook广告模板',
    isDefaultTemplate: '是否默认模板',
    templateDesc: '模板描述',
    templateDescPlaceholder: '请输入模板描述',
    remarkPlaceholder: '请输入备注',
    nameRequired: '请输入模板名称',
    // Tab labels
    tabBasic: '基础信息',
    tabCampaign: '广告系列',
    tabAdset: '广告组',
    tabConversion: '转化跟踪',
    tabTargeting: '受众定向',
    tabCreative: '广告创意',
    tabAccount: '账户配置',
    // Campaign tab
    campaignName: '系列名称',
    campaignNamePlaceholder: '系列名称前缀',
    campaignObjective: '广告系列目标',
    campaignDailyBudget: '系列每日预算(分)',
    campaignLifetimeBudget: '系列总预算(分)',
    specialAdCategory: '特殊广告类别',
    specialAdCategoryPlaceholder: '请选择特殊广告类别',
    campaignStatus: '广告系列状态',
    bidStrategy: '竞价策略',
    // Adset tab
    adsetName: '广告组名称',
    adsetNamePlaceholder: '广告组名称前缀',
    optimizationGoal: '优化目标',
    billingEvent: '计费事件',
    adsetBidStrategy: '出价策略',
    adsetDailyBudget: '每日预算(分)',
    adsetLifetimeBudget: '总预算(分)',
    adsetStatus: '广告组状态',
    // Conversion tab
    pixelId: 'Facebook像素ID',
    pixelIdPlaceholder: '请输入像素ID',
    conversionEventType: '转化事件类型',
    clickAttribution: '点击归因窗口(天)',
    viewAttribution: '浏览归因窗口(天)',
    attributionWeight: '归因权重',
    // Targeting tab
    basicTargeting: '基础定向',
    targetCountry: '目标国家',
    targetCountryPlaceholder: '请选择国家',
    genderTargeting: '性别定向',
    genderAll: '全部',
    genderMale: '男性',
    genderFemale: '女性',
    ageMin: '最小年龄',
    ageMax: '最大年龄',
    advantageAudience: 'Advantage Audience',
    disabled: '禁用',
    enabled: '启用',
    placementConfig: '版位配置 (Placements)',
    devicePlatform: '设备平台',
    devicePlatformPlaceholder: '默认: 所有设备',
    publisherPlatform: '发行商平台',
    publisherPlatformPlaceholder: '默认: 所有平台',
    fbPositions: 'Facebook版位',
    fbPositionsPlaceholder: '默认: 所有版位',
    igPositions: 'Instagram版位',
    igPositionsPlaceholder: '默认: 所有版位',
    flexibleTargeting: '灵活定向 (Flexible Targeting)',
    flexibleTargetingJson: '灵活定向JSON',
    flexibleTargetingHint: '组间 AND / 组内 OR，请输入有效的 JSON 数组',
    flexibleTargetingError: '灵活定向JSON格式不正确',
    // Creative tab
    creativeName: '创意名称',
    creativeNamePlaceholder: '请输入创意名称',
    ctaType: '行动按钮类型',
    defaultHeadline: '默认广告标题',
    defaultHeadlinePlaceholder: '请输入默认广告标题',
    defaultDescription: '默认广告描述',
    defaultDescriptionPlaceholder: '请输入默认广告描述',
    defaultBody: '默认广告正文',
    defaultBodyPlaceholder: '请输入默认广告正文',
    defaultLandingUrl: '默认落地页链接',
    defaultImageHash: '默认图片hash',
    defaultImageHashPlaceholder: '请输入默认图片hash',
    defaultVideoId: '默认视频ID',
    defaultVideoIdPlaceholder: '请输入默认视频ID',
    adStatus: '广告状态',
    // Account tab
    fbPageId: 'Facebook页面ID',
    fbPageIdPlaceholder: '请输入页面ID',
    fbAccountId: 'Facebook账户ID',
    accessTokenLabel: '访问令牌',
    accessTokenPlaceholder: '请输入访问令牌（可选，为空时使用系统Token管理）',
    // Messages
    copyPrompt: '请输入新模板名称',
    copyTitle: '复制模板',
    copySuffix: ' (副本)',
    copySuccess: '复制成功',
    deleteConfirm: '是否确认删除模板「{name}」？',
    deleteWarning: '警告',
    deleteSuccess: '删除成功',
    batchDeleteConfirm: '是否确认删除选中的 {count} 个模板？',
    createSuccess: '创建成功',
    updateSuccess: '修改成功',
    operationFail: '操作失败',
    getDetailFail: '获取模板详情失败'
  },
  batchCreate: {
    title: '创建批量广告任务',
    cancel: '取消',
    createTask: '创建任务',
    selectTemplate: '选择模板',
    selectTemplatePlaceholder: '请选择广告模板（可选）',
    defaultSuffix: ' (默认)',
    adAccount: '广告账户',
    adAccountPlaceholder: '请选择广告账户',
    pageId: '公共页',
    pageIdPlaceholder: '请输入 Facebook 公共页 ID',
    pixelId: 'Pixel ID',
    pixelIdPlaceholder: '请输入 Facebook Pixel ID',
    campaignConfig: '广告系列配置',
    campaignIndex: '系列 {index}',
    campaignName: '系列名称',
    campaignNamePlaceholder: '系列名称',
    landingPageUrl: '落地页URL',
    adsetCount: '广告组数量',
    adTitle: '广告标题',
    adTitlePlaceholder: '广告标题',
    adBody: '广告正文',
    adBodyPlaceholder: '广告正文',
    selectMaterial: '选择素材',
    selectMaterialPlaceholder: '请选择素材',
    addCampaign: '添加系列',
    // Preview
    previewTitle: '广告结构预览',
    selectedAssets: '已选资产',
    summaryAssets: '{accounts}个广告账户, {materials}个素材, {campaigns}个文案',
    publishTotal: '发布总数',
    summaryPublish: '{campaigns}个广告系列, {adsets}个广告组, {ads}个广告',
    // Validation
    accountRequired: '请至少选择一个广告账户',
    campaignRequired: '请至少添加一个广告系列',
    campaignNameRequired: '请填写系列 {index} 的名称',
    // Submit
    confirmTitle: '确认创建',
    confirmMsg: '即将创建 {count} 条广告，是否确认？',
    confirmBtn: '确认创建',
    successMsg: '批创完成！成功 {success} 条，失败 {fail} 条',
    failMsg: '批量创建失败: '
  }
};
